import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { axiosInstance } from '../App';
import CreateBookingStepper from './CreateBookingStepper';
import { toast } from 'sonner';
import { decryptId } from '../utils/urlEncryption';

const EditBooking = ({ user, onLogout }) => {
  const { bookingId: encryptedBookingId } = useParams();
  const navigate = useNavigate();
  
  // Decrypt the booking ID from URL
  const bookingId = decryptId(encryptedBookingId);
  
  const [bookingData, setBookingData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadBookingData();
  }, [bookingId]);

  const loadBookingData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/bookings/${bookingId}`);
      setBookingData(response.data);
    } catch (error) {
      console.error('Error loading booking:', error);
      toast.error('Failed to load booking data');
      navigate('/bookings');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-amber-50 via-white to-orange-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600 mx-auto"></div>
          <p className="text-gray-600 mt-4">Loading booking data...</p>
        </div>
      </div>
    );
  }

  if (!bookingData) {
    return null;
  }

  return (
    <CreateBookingStepper
      user={user}
      onLogout={onLogout}
      editMode={true}
      existingBooking={bookingData}
    />
  );
};

export default EditBooking;
